import styles from './SponsoredBadge.module.scss';

export function SponsoredBadge({ onClick }: { onClick: () => void }) {
  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.content}>реклама • adengi.ru</div>
    </div>
  );
}
